import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpService } from './http.service';
import { LegacyBookInitService } from './legacy-book-initializer.service';
import { SharedService } from './shared.service';

@Injectable()
export class StayenhanceService {
  commonURL: string = '';
  tenantId: any;
  bookData: any;
  public ConfigDetails: any;
  propertyName: any;
  errorMessage: string = '';
  constructor(
    private _http: HttpClient,
    private httpService: HttpService,
    private configservice: LegacyBookInitService,
    private router: Router,
    public SharedService: SharedService
  ) {
    this.commonURL = this.configservice.getenhanceData();
    this.tenantId = configservice.gettenantId();
    this.propertyName = configservice.PropertyData.PropNameKeyList.enhance;
  }
  getConfigDetails(offer, arrivalDate, departureDate, guest, refineSearch, roomCode): Observable<any[] | ArrayBuffer> {
    let url;
    let adult;
    let paramsString;
    paramsString = JSON.parse(JSON.stringify(this.configservice.serviceHeaders));
    if (refineSearch) {
      let params = new HttpParams();
      this.configservice.guestTypeLimit.forEach((element) => {
        if (element['selectedValue'] && Number(element['selectedValue']) > 0 && element['key'] !== 'adults') {
          params = params.set(element.key, element.selectedValue);
        } else if (element['key'] === 'adults') {
          adult = element['selectedValue'];
        }
      });
      console.log(params);
      paramsString.params = params;
    } else {
      adult = guest;
    }
    if (this.configservice.PropertyData.permissions.functionalPermissions.allowEnhancementSelectionForSpecificDays) {
      url =
        this.configservice.getCloudDomainName() +
        '/' +
        this.commonURL +
        '/tenants/' +
        this.tenantId +
        ('/context/' + this.configservice.PropertyData.ContextId + '/') +
        'propertyName/' +
        this.propertyName +
        '/arrivalDate/' +
        arrivalDate +
        '/departureDate/' +
        departureDate +
        '/adults/' +
        adult +
        '?appName=wbe&locale=' +
        this.configservice?.PropertyData?.langCode +
        '&roomCode=' +
        roomCode +
        '&offer=' +
        encodeURIComponent(offer) +
        '&nightlyRate=True';
    } else {
      url =
        this.configservice.getCloudDomainName() +
        '/' +
        this.commonURL +
        '/tenants/' +
        this.tenantId +
        ('/context/' + this.configservice.PropertyData.ContextId + '/') +
        'propertyName/' +
        this.propertyName +
        '/arrivalDate/' +
        arrivalDate +
        '/departureDate/' +
        departureDate +
        '/adults/' +
        adult +
        '?appName=wbe&locale=' +
        this.configservice?.PropertyData?.langCode +
        '&roomCode=' +
        roomCode +
        '&offer=' +
        encodeURIComponent(offer);
    }
    return this.httpService.get(url, paramsString).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
  private errorHandle = (error) => {
    console.log(error);
    this.errorMessage = error.ErrorMessage;
  };
}
